export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-asterisk-a29e7919481175fdac44bd096a7b24ff.svg";